module.exports = __webpack_public_path__ + "pc/img/gradient.26569e35.png";